import { ESLCourseData } from "../../data/ESL/ESLCourseData";
import ESLCourseTemplate from "../../pageTemplate/ESLCourseTemplate";
export default function ESLCOPage() {
    return (
        <div>
            <ESLCourseTemplate data={ESLCourseData[0]} />
        </div>
    )
}